import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import 'lib/hyperdx';
import './index.css';
import 'antd/dist/antd.css';
import App from './App';
import { store } from './app/store';
import CustomErrorBoundary from 'components/ErrorBoundary';
import { QueryClient, QueryClientProvider } from 'react-query';
import { CubeProvider } from '@cubejs-client/react';
import cubejsApi from './utils/cubejs';

const queryClient = new QueryClient();

const container = document.getElementById('root');

ReactDOM.render(
  <React.StrictMode>
    <CustomErrorBoundary>
      <BrowserRouter basename='/'>
        <Provider store={store}>
          <QueryClientProvider client={queryClient}>
            <CubeProvider cubeApi={cubejsApi}>
              <App />
            </CubeProvider>
          </QueryClientProvider>
        </Provider>
      </BrowserRouter>
    </CustomErrorBoundary>
  </React.StrictMode>,
  container
);